import type { TripTimeline } from '../trip-timeline.api';

/** The instant the run's days are counted from: the first thing that happened, or failing that the first planned time. Null for a timeline with no time at all. */
export function referenceTime(timeline: TripTimeline): string | null {
  const times = timeline.stops.flatMap((stop) => stop.actuals.map((actual) => actual.at));
  return times.sort()[0] ?? timeline.stops.find((stop) => stop.planned.arrivalAt)?.planned.arrivalAt ?? null;
}
